import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { ScaService } from '@platform-frontend/marketplace';
import { SimpleRouterState } from '@platform-frontend/util';

export const ScaGuard: CanActivateFn = () => {
  const store = inject(Store);
  const scaService = inject(ScaService);
  if (store.selectSnapshot(SimpleRouterState.guardsActivated)) {
    return scaService.isInProgress();
  } else {
    return true;
  }
};
